import React from "react";
import { Empty, Spin, Row, Col } from "antd";
import LocationCard from "./LocationCard";
import type { Location } from "../../../../../types/location";

interface LocationGridProps {
  locations: Location[];
  loading?: boolean;
}

const LocationGrid: React.FC<LocationGridProps> = ({ locations, loading }) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "48px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (locations.length === 0) {
    return (
      <div style={{ padding: "48px 0" }}>
        <Empty description="No locations found" />
      </div>
    );
  }

  return (
    <Row gutter={[24, 24]}>
      {locations.map((location) => (
        <Col key={location.id} xs={24} sm={12} lg={8}>
          <LocationCard location={location} />
        </Col>
      ))}
    </Row>
  );
};

export default LocationGrid;
